import { memo, useCallback, useState } from "react";

import { observer } from "mobx-react-lite";

import iconLeave from "../../../assets/images/100-close.svg";
import iconComments from "../../../assets/images/100-comments.svg";
import iconParticipants from "../../../assets/images/100-participants.svg";
import { useAuth } from "../../../contexts/authContext";
import { useGlobal } from "../../../contexts/globalContext";
import { useMeetingDetailsStore } from "../../../contexts/meetingDetails/meetingDetailsContext";
import { useApi } from "../../../hooks/useApi";

const CurrentMeetingControls = () => {
  const { MEETING_STATE } = useGlobal();
  const { leaveMeeting } = useApi();
  const { participants, meeting, setIsLeaving, initLeaving, updateInitLeaving } = useMeetingDetailsStore();
  const { userData } = useAuth();
  const [isRemovingUser, setIsRemovingUser] = useState(false);

  const invitedParticipants = participants.filter((participant) => participant.user.uid !== userData.uid);

  const handleLeaveProcess = useCallback(() => {
    if (!initLeaving) {
      setIsRemovingUser(true);
      updateInitLeaving(true);
      leaveMeeting(meeting.mid)
        .then(() => {
          setIsLeaving(true);
          setIsRemovingUser(false);
        })
        .catch((e) => console.log(e));
    }
  }, []);

  return (
    <div className="align-items-center m-lr-10">
      {!!invitedParticipants.length && (
        <>
          <div className="icon-with-count m-l-6">
            <img src={iconParticipants} width="16" height="16" className="m-4 pointer" alt="" />
            <span>{MEETING_STATE.users.active.length}</span>
          </div>
          <div className="icon-with-count">
            <img src={iconComments} width="16" height="16" className="m-4 pointer" alt="" />
            <span> 10 </span>
          </div>
        </>
      )}
      <div className={`m-l-6 flex ${isRemovingUser ? "fn__loading" : ""}`} onClick={handleLeaveProcess}>
        <img src={iconLeave} width="16" height="16" className="m-4 pointer" alt="" />
      </div>
    </div>
  );
};

export default memo(observer(CurrentMeetingControls));
